import {h, Component, Fragment} from "preact";
import {route} from "preact-router";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import PFeed from "../../../services/prematch-feed";
import Page from "../../../services/page-data-feed";
import Config from "../../../services/config";
import Ticket from "../utils/ticket-logic.jsx";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as P from "../desktop-templates/prematch-tournament.jsx";
import {StatsIconRegular} from "../utils/icons.jsx";
import AwrabetPrematchLastminute, {
    PrematchLastminuteContent as AwrabetPrematchLastminuteContent,
    PrematchEventOdds as AwrabetPrematchEventOdds
} from '../../awrabet/desktop-components/prematch-last-minute.jsx';

export default class PrematchLastminute extends AwrabetPrematchLastminute {
	render() {
		if (!PFeed.menu)
			return;
		const sport = this.bestSport(PFeed.menu);
		return <PrematchLastminuteContent defaultSport={sport.id} />
	}
}

export class PrematchLastminuteContent extends AwrabetPrematchLastminuteContent {

    render() {
        return <div>
		  <P.CardHeaderRow>
			<P.ThreeDots />
			<P.CardHeaderTitle><Trans>Last Minute</Trans></P.CardHeaderTitle>
			<P.CardHeaderSports>
			  {this.bestFourSports(PFeed.menu).map(sport => (
				<P.SportNameButton onClick={() => this.setCurrentSport(sport.id)} active={this.isCurrentSport(sport.id)}>
				  <M.SportFlagIcon sport={sport} /> {sport.name}
				</P.SportNameButton>
			  ))}
			</P.CardHeaderSports>
		  </P.CardHeaderRow>
		  <P.OddsTableHeadRow>
			<P.HeadRowCellId><Trans>Stats</Trans></P.HeadRowCellId>
			<P.HeadRowCellTime><Trans>Time</Trans></P.HeadRowCellTime>
			<P.HeadRowCellEvent><Trans>Event</Trans></P.HeadRowCellEvent>
			<P.OddsWidthContainer>
			  {this.preferredMarkets[this.getCurrentSportId()].outcomes == 3 ? <Fragment>
			    <P.HeadOddCell><Trans>1</Trans></P.HeadOddCell>
			    <P.HeadOddCell><Trans>X</Trans></P.HeadOddCell>
			    <P.HeadOddCell><Trans>2</Trans></P.HeadOddCell>
			  </Fragment>
			  : <Fragment>
			    <P.HeadOddCell><Trans>1</Trans></P.HeadOddCell>
			    <P.HeadOddCell><Trans>2</Trans></P.HeadOddCell>
			  </Fragment>}
			  <P.HeadMoreCell />
			</P.OddsWidthContainer>
		  </P.OddsTableHeadRow>
		  {this.getSomeEvents().map(event => <div>
			  <P.EventRow>
				<P.HeadRowCellId onClick={e => Page.openEventStats(event)}><StatsIconRegular class="h-4" /></P.HeadRowCellId>
				<P.HeadRowCellTime onClick={e => this.openEvent(event)}><span class="text-xxs">{this.getLocalEventTime(event)}</span></P.HeadRowCellTime>
				<P.ContentRowCellEvent onClick={e => this.openEvent(event)}>{event.home}{event.away ? ' - '+event.away : ''}</P.ContentRowCellEvent>
				<P.OddsWidthContainer>
					<PrematchEventOdds event={event} market={this.preferredMarketForEvent(event)} />
					<P.MoreButton onClick={e => this.openEvent(event)}>+</P.MoreButton>
				</P.OddsWidthContainer>
			  </P.EventRow>
		  </div>)}
		  <P.ShowMoreFooter><Trans>Show More</Trans> {">>"}</P.ShowMoreFooter>
		</div>;
    }
}

export class PrematchEventOdds extends AwrabetPrematchEventOdds {

	render({market, event}) {
		return !!market ? Object.values(market.sub).map(outcome => (
			<P.EventOddButton
				value={outcome && outcome.value}
				selected={outcome && Ticket.hasPrematchOdds(outcome.id)}
				onClick={() => Ticket.togglePrematchOdds(outcome.id)} />
		)) : <P.OddsWidthEmpty />
	}
}